import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

// Risoluzione dinamica dell'URL per evitare conflitti Staging vs Produzione
const getBackendUrl = () => {
    if (typeof window !== "undefined") {
        const hostname = window.location.hostname;
        if (hostname.includes("test.magicmixapp.ch")) {
            return "https://test.magicmixapp.ch";
        } else if (hostname.includes("magicmixapp.ch")) {
            return "https://magicmixapp.ch";
        }
    }
    return process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_URL || "https://test.magicmixapp.ch";
};

const API = `${getBackendUrl()}/api`;

const OpenInSafari = () => {
    const [searchParams] = useSearchParams();
    const exchangeToken = searchParams.get("exchange_token");
    const [status, setStatus] = useState("exchanging"); // "exchanging" | "success" | "error"
    const [errorMsg, setErrorMsg] = useState("");

    useEffect(() => {
        if (!exchangeToken) {
            setStatus("error");
            setErrorMsg("No exchange token found in the URL. Please request a new link.");
            return;
        }

        const triggerExchange = async () => {
            try {
                // Chiamata all'endpoint di scambio sul backend con credenziali (per i cookie)
                await axios.get(`${API}/auth/magic-exchange`, {
                    params: { exchange_token: exchangeToken },
                    withCredentials: true
                });
                
                setStatus("success");
                
                // Piccolo delay visivo per dare feedback e poi reindirizzamento alla dashboard
                setTimeout(() => {
                    window.location.href = "/";
                }, 1500);
            } catch (err) {
                console.error("Exchange error:", err);
                setStatus("error");
                setErrorMsg(
                    err.response?.data?.detail || 
                    "An error occurred while finishing your sign-in. Please try again."
                );
            }
        };

        triggerExchange();
    }, [exchangeToken]);

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            width: "100vw",
            backgroundColor: "#0a0a0a",
            color: "#ffffff",
            fontFamily: "sans-serif",
            padding: "20px",
            boxSizing: "border-box"
        }}>
            <div style={{ textAlign: "center", maxWidth: "400px" }}>
                <h1 style={{ color: "#00f0ff", fontSize: "36px", fontWeight: "900", letterSpacing: "4px", margin: "0 0 10px 0" }}>
                    MAGIC MIX
                </h1>
                
                {status === "exchanging" && (
                    <>
                        <div style={{
                            width: "40px",
                            height: "40px",
                            border: "3px solid rgba(0, 240, 255, 0.1)",
                            borderTop: "3px solid #00f0ff",
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite",
                            margin: "30px auto"
                        }} />
                        <style>{`
                            @keyframes spin {
                                0% { transform: rotate(0deg); }
                                100% { transform: rotate(360deg); }
                            }
                        `}</style>
                        <p style={{ color: "#ffffff", opacity: 0.8, fontSize: "14px", letterSpacing: "1px" }}>
                            Completing your secure sign-in...
                        </p>
                    </>
                )}

                {status === "success" && (
                    <div style={{ marginTop: "20px" }}>
                        <span style={{ fontSize: "50px" }}>⚡</span>
                        <h2 style={{ fontSize: "20px", margin: "15px 0 5px 0", color: "#00f0ff" }}>Success!</h2>
                        <p style={{ color: "#ffffff", opacity: 0.6, fontSize: "14px" }}>
                            Redirecting to your dashboard...
                        </p>
                    </div>
                )}

                {status === "error" && (
                    <div style={{ marginTop: "20px" }}>
                        <span style={{ fontSize: "50px" }}>⚠️</span>
                        <h2 style={{ fontSize: "20px", margin: "15px 0 10px 0", color: "#ff4a4a" }}>Sign-In Failed</h2>
                        <p style={{ color: "#ffffff", opacity: 0.7, fontSize: "14px", marginBottom: "30px" }}>
                            {errorMsg}
                        </p>
                        <a 
                            href="/"
                            style={{
                                display: "inline-block",
                                backgroundColor: "#00f0ff",
                                color: "#0a0a0a",
                                textDecoration: "none",
                                padding: "12px 24px",
                                borderRadius: "6px",
                                fontWeight: "bold",
                                fontSize: "14px",
                                transition: "opacity 0.2s"
                            }}
                            onMouseOver={(e) => e.currentTarget.style.opacity = "0.8"}
                            onMouseOut={(e) => e.currentTarget.style.opacity = "1"}
                        >
                            Back to Login
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};

export default OpenInSafari;
